import React, { useContext, useEffect, useState } from "react";
import { Button, Grid, Stack, TextField } from "@mui/material";
import "../../../styles/Layout/Admin_Styles/_PrintApplication.scss";
import { decrypt } from "../../../utils/encryptDecrypt";
import { fDate } from "../../../utils/formatTime";
import { appPrefix, calculateAge } from "../../../utils/helpers";
import profile from "../../../assets/photo.png";
import sign from "../../../assets/signature.png";
import SearchImg from "../../../assets/search-print-view.gif";
import NoDataFound from "../../../shared/NoDataFound/NoDataFound";
import { authHttp } from "../../services/utility";
import { apisPath } from "../../../utils/path";
import AdminConfirmationDetails from "../AdminConfirmationDetails/AdminConfirmationDetails";
import { AuthContext } from "../../../context/AuthContext";

const PrintPaymentSlip = () => {
  const { setAlertState, setIsLoading } = useContext(AuthContext);
  const [applicationSearch, setApplicationSearch] = useState();
  const [appliedPost, setAppliedPost] = useState([]);
  const [paymentDetails, setPaymentDetails] = useState({});
  const [email, setEmail] = useState("-");

  const getData = (searchData) => {
    setIsLoading(true);
    authHttp
      .post(apisPath?.admin?.printApplication, searchData)
      .then((res) => {
        // console.log("print application:" + decrypt(res?.data?.data?.name));
        if (Object.keys(res?.data?.data).length) {
          if (parseInt(res?.data?.data?.amount) || res?.data?.data?.amount === null) {
            const applied = res?.data?.data?.applied_post?.map((data) => {
              return data?.name;
            });
            const tempEmail = decrypt(res?.data?.data?.email);
            if (tempEmail?.includes("@")) {
              const first = tempEmail?.split("@")[0];
              const second = tempEmail?.split("@")[1];
              let masked = "";
              for (let i = 3; i < first?.length; i++) {
                masked += "X";
              }
              setEmail(`${first?.slice(0, 3)}${masked}@${second}`);
            }
            setAppliedPost(applied ? applied : []);
            setPaymentDetails(res?.data?.data);
            setIsLoading(false);
          } else {
            setIsLoading(false);
            setAlertState((prev) => ({
              ...prev,
              open: true,
              title: "Fee Exempted for this application number",
              btnTxt: "CLOSE",
              status: "fail",
            }));
          }
        } else {
          setIsLoading(false);
          setPaymentDetails({});
          setEmail("-");
          setAppliedPost([]);
          setAlertState((prev) => ({
            ...prev,
            open: true,
            title: "Invalid application number",
            btnTxt: "CLOSE",
            status: "fail",
          }));
        }
      })
      .catch((err) => {
        setIsLoading(false);
        setPaymentDetails({})
        setAlertState((prev) => ({
          ...prev,
          open: true,
          title: err?.response?.data?.msg,
          btnTxt: "CLOSE",
          status: "fail",
          isSessionExpire: err?.response?.status === 401,
          sessionType: "admin",
        }));
      });
  };

  return (
    <div className="print-application">
      <div className="print-application--header">
        <h2>Print Payment Slip</h2>
      </div>
      <Grid container spacing={2} alignItems="center" className={"print-application--search"}>
        <Grid item lg={4} md={4} sm={4} xs={12}>
          <TextField
            autoComplete="off"
            id="application_number"
            label="Enter Application Number"
            onChange={(e) => setApplicationSearch(e.target.value)}
            variant="outlined"
            fullWidth
          />
        </Grid>
        <Grid item lg={5} md={5} sm={5} xs={12}>
          <div className="print-application--button">
            <Button
              variant="contained"
              onClick={() => {
                if (applicationSearch) {
                  getData({
                    application_no: applicationSearch.toUpperCase().replace(appPrefix, "")
                  });
                }
              }}
            >
              Search
            </Button>
          </div>
        </Grid>
      </Grid>
      {Object.keys(paymentDetails)?.length > 0 ? (
        <>
          <AdminConfirmationDetails
            paymentDetails={paymentDetails}
            email={email}
            appliedPost={appliedPost}
          />
          {/* <div className="print-application--printbtn">
            <Button variant="outlined" color="success">
              Print Payment Reciept
            </Button>
          </div> */}
        </>
      ) : (
        <div className="print-application--img">
          <img src={SearchImg} alt="" />
        </div>
      )}
    </div>
  );
};

export default PrintPaymentSlip;
